/* =====================================================
   HARBOR HEIGHTS COFFEE — Complete JavaScript
   Particles, scroll reveals, parallax, quiz, counters, CleanHub
   ===================================================== */

(function() {
  'use strict';

  /* ── Particles Canvas (Hero floating lights) ── */
  function initParticlesOn(canvas) {
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var particles = [];
    var animFrameId;

    function resize() {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    }

    function createParticles() {
      particles.length = 0;
      var count = Math.floor((canvas.width * canvas.height) / 18000);
      for (var i = 0; i < count; i++) {
        particles.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          size: Math.random() * 2 + 0.5,
          speedX: (Math.random() - 0.5) * 0.3,
          speedY: (Math.random() - 0.5) * 0.3,
          opacity: Math.random() * 0.6 + 0.1,
          opacityDir: Math.random() > 0.5 ? 1 : -1
        });
      }
    }

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.x += p.speedX;
        p.y += p.speedY;
        p.opacity += p.opacityDir * 0.003;
        if (p.opacity > 0.7) p.opacityDir = -1;
        if (p.opacity < 0.05) p.opacityDir = 1;
        if (p.x < 0) p.x = canvas.width;
        if (p.x > canvas.width) p.x = 0;
        if (p.y < 0) p.y = canvas.height;
        if (p.y > canvas.height) p.y = 0;

        var gradient = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.size * 3);
        gradient.addColorStop(0, 'rgba(245, 237, 214, ' + p.opacity + ')');
        gradient.addColorStop(0.5, 'rgba(28, 105, 128, ' + (p.opacity * 0.4) + ')');
        gradient.addColorStop(1, 'rgba(28, 105, 128, 0)');

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size * 3, 0, Math.PI * 2);
        ctx.fillStyle = gradient;
        ctx.fill();
      }
      animFrameId = requestAnimationFrame(draw);
    }

    resize();
    createParticles();

    window.addEventListener('resize', function() {
      resize();
      createParticles();
    });

    draw();
  }

  /* ── Scroll Reveal via IntersectionObserver ── */
  function initScrollReveal() {
    var selectors = '.section-reveal, .section-reveal-left, .section-reveal-right';
    var els = document.querySelectorAll(selectors);
    if (!els.length) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function(el) { observer.observe(el); });
  }

  /* ── Animated Counter ── */
  function animateCounter(el, target, suffix, duration) {
    suffix = suffix || '';
    duration = duration || 2400;
    var start = 0;
    var step = Math.max(1, Math.ceil(target / (duration / 16)));
    function tick() {
      start += step;
      if (start >= target) {
        el.textContent = target.toLocaleString() + suffix;
        return;
      }
      el.textContent = start.toLocaleString() + suffix;
      requestAnimationFrame(tick);
    }
    tick();
  }

  function initCounters() {
    var counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var target = parseInt(entry.target.getAttribute('data-counter'), 10);
          var suffix = entry.target.getAttribute('data-suffix') || '';
          if (target > 0) {
            animateCounter(entry.target, target, suffix);
            observer.unobserve(entry.target);
          }
        }
      });
    }, { threshold: 0.3 });
    counters.forEach(function(el) { observer.observe(el); });
  }
  window.hhInitCounters = initCounters;

  /* ── Parallax (hero content shifts on scroll) ── */
  function initParallax() {
    var hero = document.querySelector('.parallax-slow');
    if (!hero) return;
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var scrollY = window.pageYOffset;
          if (scrollY < window.innerHeight) {
            hero.style.transform = 'translateY(' + (scrollY * 0.3) + 'px)';
          }
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  /* ── Nav scroll state + mega menu + mobile drawer ── */
  function initNav() {
    var nav = document.querySelector('.hh-nav');
    if (!nav) return;

    window.addEventListener('scroll', function() {
      if (window.scrollY > 60) {
        nav.classList.add('nav-glass');
      } else {
        nav.classList.remove('nav-glass');
      }
    });

    var toggle = document.getElementById('hh-mobile-toggle');
    var drawer = document.getElementById('hh-mobile-drawer');

    function openDrawer() {
      if (!drawer || !toggle) return;
      drawer.classList.add('is-open');
      toggle.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = '-' + window.scrollY + 'px';
    }

    function closeDrawer() {
      if (!drawer || !toggle) return;
      var scrollY = document.body.style.top;
      drawer.classList.remove('is-open');
      toggle.classList.remove('is-open');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }

    if (toggle && drawer) {
      toggle.addEventListener('click', function(e) {
        e.stopPropagation();
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });

      var drawerLinks = drawer.querySelectorAll('a');
      for (var i = 0; i < drawerLinks.length; i++) {
        drawerLinks[i].addEventListener('click', closeDrawer);
      }
    }

    var anchorLinks = document.querySelectorAll('.hh-anchor-link');
    for (var a = 0; a < anchorLinks.length; a++) {
      anchorLinks[a].addEventListener('click', function(e) {
        var targetId = this.getAttribute('data-target');
        if (!targetId) return;
        var isHome = window.location.pathname === '/' || window.location.pathname === '';
        if (isHome) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          document.body.classList.remove('unloading');
          if (drawer && drawer.classList.contains('is-open')) {
            closeDrawer();
          }
          var el = document.getElementById(targetId);
          if (el) {
            setTimeout(function() {
              document.body.classList.remove('unloading');
              el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 60);
          }
          return false;
        }
      }, true);
    }

    var shopContainer = document.querySelector('.hh-shop-container');
    var megaMenu = document.querySelector('.hh-mega-menu');
    if (shopContainer && megaMenu) {
      var timeout;
      shopContainer.addEventListener('mouseenter', function() {
        clearTimeout(timeout);
        megaMenu.style.display = 'block';
        megaMenu.style.opacity = '1';
      });
      shopContainer.addEventListener('mouseleave', function() {
        timeout = setTimeout(function() {
          megaMenu.style.display = 'none';
          megaMenu.style.opacity = '0';
        }, 200);
      });

      var trigger = document.querySelector('.hh-shop-trigger');
      if (trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          if (megaMenu.style.display === 'block') {
            megaMenu.style.display = 'none';
          } else {
            megaMenu.style.display = 'block';
            megaMenu.style.opacity = '1';
          }
        });
      }
    }
  }

  /* ── Find Your Roast Quiz ── */
  function initQuiz() {
    var quizContainer = document.querySelector('.hh-quiz');
    if (!quizContainer) return;

    var products = [];
    try {
      products = JSON.parse(quizContainer.getAttribute('data-products') || '[]');
    } catch(e) { return; }
    var currentStep = -1;
    var answers = {};

    var questions = [
      { id:'moment', label:"What's your coffee moment?", subtitle:'Tell us when you reach for a cup.', options:[
        {value:'morning',label:'Morning Ritual',icon:'\u2600\uFE0F',desc:'First thing, eyes half-open'},
        {value:'focus',label:'Deep Focus',icon:'\uD83E\uDDE0',desc:'When I need to lock in'},
        {value:'afternoon',label:'Afternoon Reset',icon:'\u26F5',desc:'A pick-me-up, no jitters'},
        {value:'evening',label:'Evening Wind-Down',icon:'\uD83C\uDF19',desc:'Cozy, calm, no caffeine'}
      ]},
      { id:'flavor', label:'What flavors speak to you?', subtitle:'Pick what sounds most appealing.', options:[
        {value:'chocolate',label:'Chocolate & Nutty',icon:'\uD83C\uDF6B',desc:'Rich, warm, comforting'},
        {value:'fruit',label:'Fruity & Bright',icon:'\uD83C\uDF52',desc:'Berry, citrus, lively'},
        {value:'earthy',label:'Earthy & Bold',icon:'\uD83C\uDF3F',desc:'Deep, smoky, grounding'},
        {value:'sweet',label:'Caramel & Sweet',icon:'\uD83C\uDF6F',desc:'Smooth, syrupy, balanced'}
      ]},
      { id:'brew', label:'How do you brew?', subtitle:'Your method helps us match the format.', options:[
        {value:'pourover',label:'Pour-Over / Drip',icon:'\u2615',desc:'Ground beans, full control'},
        {value:'espresso',label:'Espresso',icon:'\u26A1',desc:'Concentrated, intense'},
        {value:'pods',label:'Single-Serve Pods',icon:'\uD83D\uDC8A',desc:'Quick, consistent, easy'},
        {value:'instant',label:'Instant / On-the-Go',icon:'\uD83C\uDFC3',desc:'Just add water, anywhere'}
      ]},
      { id:'intensity', label:'How bold do you like it?', subtitle:'Your roast preference.', options:[
        {value:'light',label:'Light & Delicate',icon:'\uD83C\uDF38',desc:'Nuanced, tea-like clarity'},
        {value:'medium',label:'Medium & Balanced',icon:'\u2696\uFE0F',desc:'The sweet spot'},
        {value:'dark',label:'Dark & Robust',icon:'\uD83C\uDF11',desc:'Full body, bold flavors'},
        {value:'surprise',label:'Surprise Me',icon:'\uD83C\uDFB2',desc:"I'm open to anything"}
      ]}
    ];

    function scoreProduct(p) {
      var score = 0;
      var m = answers.moment;
      if (m === 'morning' && /Medium/.test(p.roast)) score += 3;
      if (m === 'focus' && (p.collection === 'Wellness' || /Lion|Chaga|matcha/i.test(p.notes))) score += 5;
      if (m === 'afternoon' && /Light/.test(p.roast)) score += 3;
      if (m === 'evening' && p.collection === 'Decaf') score += 8;
      if (m === 'evening' && /matcha/i.test(p.name)) score += 4;

      var f = answers.flavor;
      if (f === 'chocolate' && /chocolate|cocoa|toffee|almond|praline/i.test(p.notes)) score += 4;
      if (f === 'fruit' && /berry|cherry|citrus|fruit|plum|grape|apple/i.test(p.notes)) score += 4;
      if (f === 'earthy' && /earth|herbal|smoke|cedar|nori|umami/i.test(p.notes)) score += 4;
      if (f === 'sweet' && /caramel|sugar|maple|honey|sweet|cane/i.test(p.notes)) score += 4;

      var b = answers.brew;
      if (b === 'pods' && p.weight === '12 Pods') score += 6;
      if (b === 'pods' && p.weight !== '12 Pods') score -= 2;
      if (b === 'instant' && p.collection === 'Instant') score += 6;
      if (b === 'instant' && /instant/i.test(p.name)) score += 4;
      if (b === 'instant' && /matcha/i.test(p.name)) score += 3;
      if (b === 'pourover' && /12 oz/.test(p.weight)) score += 2;
      if (b === 'espresso' && /Dark|French/.test(p.roast)) score += 2;

      var i = answers.intensity;
      if (i === 'light' && /Light/.test(p.roast)) score += 4;
      if (i === 'medium' && /Medium/.test(p.roast)) score += 4;
      if (i === 'dark' && /Dark|French/.test(p.roast)) score += 4;
      if (i === 'surprise') score += 1;
      if (p.collection === 'Single Origin') score += 1;
      return score;
    }

    function render() {
      var html = '';
      if (currentStep === -1) {
        html += '<div class="quiz-transition" style="text-align:center">';
        html += '<button class="btn-amber quiz-start" style="width:100%;max-width:320px;padding:18px 48px;font-size:15px;cursor:pointer">Start the Quiz</button>';
        html += '<div style="margin-top:16px"><a href="/collections/all" style="font-size:13px;color:rgba(245,237,214,0.35);text-decoration:none;letter-spacing:0.05em">or browse all products \u2192</a></div>';
        html += '</div>';
      } else if (currentStep < questions.length) {
        var q = questions[currentStep];
        html += '<div class="quiz-transition">';
        html += '<div style="display:flex;gap:8px;justify-content:center;margin-bottom:40px">';
        for (var d = 0; d < questions.length; d++) {
          html += '<div style="width:' + (d === currentStep ? 32 : 8) + 'px;height:8px;border-radius:4px;background:' + (d <= currentStep ? 'var(--teal-light)' : 'rgba(245,237,214,0.15)') + ';transition:all 0.4s ease"></div>';
        }
        html += '</div>';
        html += '<div style="text-align:center;margin-bottom:32px">';
        html += '<h3 style="font-family:\'Petrona\',serif;font-size:clamp(1.4rem,3vw,1.8rem);font-weight:700;color:var(--cream);margin:0 0 8px">' + q.label + '</h3>';
        html += '<p style="font-size:14px;color:rgba(245,237,214,0.4);margin:0">' + q.subtitle + '</p>';
        html += '</div>';
        html += '<div style="display:grid;gap:12px">';
        q.options.forEach(function(opt) {
          var sel = answers[q.id] === opt.value;
          html += '<button class="quiz-option' + (sel ? ' selected' : '') + '" data-question="' + q.id + '" data-value="' + opt.value + '">';
          html += '<span style="font-size:28px;line-height:1;flex-shrink:0">' + opt.icon + '</span>';
          html += '<div><div style="font-family:\'Petrona\',serif;font-size:16px;font-weight:700;color:' + (sel ? 'var(--teal-light)' : 'var(--cream)') + ';margin-bottom:4px">' + opt.label + '</div>';
          html += '<div style="font-size:12px;color:rgba(245,237,214,0.4);line-height:1.4">' + opt.desc + '</div></div>';
          if (sel) html += '<div style="margin-left:auto;width:24px;height:24px;border-radius:50%;background:var(--teal-light);display:flex;align-items:center;justify-content:center;font-size:14px;color:#fff;flex-shrink:0">\u2713</div>';
          html += '</button>';
        });
        html += '</div>';
        if (currentStep > 0) {
          html += '<button class="quiz-back" style="display:block;margin:24px auto 0;background:none;border:none;color:rgba(245,237,214,0.35);font-size:13px;cursor:pointer;letter-spacing:0.05em">\u2190 Go Back</button>';
        }
        html += '</div>';
      } else {
        var scored = products.map(function(p) { return { product: p, score: scoreProduct(p) }; });
        scored.sort(function(a, b) { return b.score - a.score; });
        var top4 = scored.slice(0, 4);
        html += '<div class="quiz-transition">';
        html += '<div style="display:grid;gap:16px;margin-bottom:40px">';
        top4.forEach(function(item, idx) {
          var p = item.product;
          var isTop = idx === 0;
          html += '<a href="' + p.url + '" class="result-card' + (isTop ? ' top-match' : '') + '">';
          if (isTop) html += '<div style="position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,var(--teal-light),var(--amber),var(--teal-light))"></div>';
          html += '<div style="display:flex;align-items:flex-start;gap:20px;position:relative">';
          html += '<div style="width:40px;height:40px;border-radius:50%;background:' + (isTop ? 'var(--teal-light)' : 'rgba(245,237,214,0.08)') + ';display:flex;align-items:center;justify-content:center;font-family:\'Petrona\',serif;font-size:' + (isTop ? 18 : 16) + 'px;font-weight:900;color:' + (isTop ? '#fff' : 'rgba(245,237,214,0.4)') + ';flex-shrink:0">' + (idx + 1) + '</div>';
          html += '<div style="flex:1;min-width:0">';
          html += '<div style="display:flex;align-items:center;gap:10px;margin-bottom:6px;flex-wrap:wrap">';
          html += '<h3 style="font-family:\'Petrona\',serif;font-size:' + (isTop ? 22 : 18) + 'px;font-weight:900;text-transform:uppercase;color:var(--cream);letter-spacing:0.04em;line-height:1.1;margin:0">' + p.name + '</h3>';
          html += '<span class="roast-pill ' + p.roastClass + '" style="font-size:9px">' + p.roast + '</span>';
          html += '</div>';
          html += '<p style="font-size:13px;color:rgba(245,237,214,0.5);margin:0 0 12px;line-height:1.6">' + p.desc + '</p>';
          html += '<div style="display:flex;align-items:center;gap:16px">';
          html += '<span style="font-family:\'Petrona\',serif;font-size:18px;font-weight:900;color:var(--cream)">' + p.price + '</span>';
          html += '<span style="font-size:11px;color:rgba(245,237,214,0.3)">' + p.weight + '</span>';
          html += '<span style="margin-left:auto;font-size:12px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:var(--teal-light)">View Details \u2192</span>';
          html += '</div></div></div></a>';
        });
        html += '</div>';
        html += '<div style="text-align:center;display:flex;flex-direction:column;gap:16px;align-items:center">';
        html += '<button class="btn-teal-outline quiz-reset" style="cursor:pointer;font-size:13px">Retake Quiz</button>';
        html += '<a href="/collections/all" class="btn-teal-outline" style="font-size:13px;text-decoration:none;display:inline-block">View Full Collection \u2192</a>';
        html += '</div></div>';
      }
      quizContainer.innerHTML = html;
      bindQuizEvents();
    }

    function bindQuizEvents() {
      var startBtn = quizContainer.querySelector('.quiz-start');
      if (startBtn) startBtn.addEventListener('click', function() { currentStep = 0; render(); });

      var options = quizContainer.querySelectorAll('.quiz-option');
      options.forEach(function(opt) {
        opt.addEventListener('click', function() {
          var qid = this.getAttribute('data-question');
          var val = this.getAttribute('data-value');
          answers[qid] = val;
          setTimeout(function() {
            if (currentStep < questions.length - 1) currentStep++;
            else currentStep = questions.length;
            render();
          }, 350);
        });
      });

      var backBtn = quizContainer.querySelector('.quiz-back');
      if (backBtn) backBtn.addEventListener('click', function() { currentStep--; render(); });

      var resetBtn = quizContainer.querySelector('.quiz-reset');
      if (resetBtn) resetBtn.addEventListener('click', function() { currentStep = -1; answers = {}; render(); });
    }

    render();
  }

  /* ── Init All ── */
  function init() {
    initParticlesOn(document.getElementById('hh-particles'));
    initParticlesOn(document.getElementById('hh-story-particles'));
    initParticlesOn(document.getElementById('hh-blog-particles'));
    initParticlesOn(document.getElementById('hh-cart-particles'));
    initParticlesOn(document.getElementById('hh-search-particles'));
    initScrollReveal();
    initCounters();
    initParallax();
    initNav();
    initQuiz();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
